import { compile, match } from 'path-to-regexp'

import routes from 'routes'

/**
 * Public API for generating a URL pathname from a path and parameters.
 * @param {string} name
 * @param {object=} params
 * @param {object} other
 * @param {string=} other.domain
 * @param {boolean=} other.forceTrailingSlash
 * @returns {string}
 */
const generatePath = (name, params = {}, { domain = '', forceTrailingSlash = true } = {}) => {
  const path = routes.list.find(route => route.name === name)
  if (!path) {
    return null
  }
  return `${domain}${compile(path.source)(params, { pretty: true })}${forceTrailingSlash ? '/' : ''}`
}

const matchUrl = (name, urlToMatch, domain = 'https://www.getapp.com') => {
  const path = routes.list.find(route => route.name === name)
  const url = new URL(domain + urlToMatch)
  return !!path && !!match(path.source)(url.pathname)
}

const getParams = (params, excludedKeys) => {
  const paramsObj = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (excludedKeys.includes(key)) {
      return
    }
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        paramsObj.append(key, value[i])
      }

      return
    }

    paramsObj.append(key, value)
  })

  if (Object.keys.length) {
    return paramsObj.toString()
  }

  return null
}

export default { generatePath, matchUrl, getParams }
